import React, { useState } from 'react';
import { Copy, Link, Square, Stack } from '@grubhubprod/gh-cookbook-react';
import { getConfig } from 'src/utilities/config';
import { CSVUploadTracking } from 'src/components/CSVUploadTracking/CSVUploadTracking';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { SimpleLoader } from 'src/components/common/SimpleLoader/SimpleLoader';

const EMPLOYEES_AMOUNT_LIMIT = 250;

interface UploadSectionProps {
  onFileUploadSuccess: () => void;
  onFileUploadError: () => void;
}

export function UploadSection({
  onFileUploadSuccess,
  onFileUploadError,
}: UploadSectionProps): JSX.Element {
  const configuration = getConfig();
  const { corpId } = useAuth();

  const [isUploadingProgressRestoring] = useState(false);

  return (
    <Square>
      <Stack y="xxx-sm">
        <Copy variant="largeCaption">Upload CSV file</Copy>
      </Stack>
      <Stack y="sm">
        <Copy variant="body" textAlign="left">
          {`If you’re assigning employees to groups in your CSV, limit groups to 
            ${EMPLOYEES_AMOUNT_LIMIT} or fewer people for scheduled team orders.
            View our `}
          <Link
            href={`${configuration.csvGuidelinesURL}`}
            rel="noreferrer noopener"
            target="_blank"
          >
            formatting guidelines.
          </Link>{' '}
        </Copy>
      </Stack>
      {isUploadingProgressRestoring ? (
        <SimpleLoader border="1px solid" borderColor="lineMedium" />
      ) : (
        <CSVUploadTracking
          corpId={corpId}
          header={(): JSX.Element => null}
          showTryAgainBtn
          showUploadErrorBanner
          allowMultipleParralelFiles={false}
          onError={onFileUploadError}
          onSuccess={onFileUploadSuccess}
        />
      )}
    </Square>
  );
}
